import { Auth, Amplify } from "aws-amplify";
import cognitoConfig from '../config/cognito.json';


async function signUp(email: string, password: string) {
    return await Auth.signUp({
        username: email,
        password,
    });
}

async function signIn(email: string, password: string) {
    return await Auth.signIn(email, password);
}

async function confirmSignUp(email: string, code: string) {
    return await Auth.confirmSignUp(email, code);
}

async function resendConfirmationCode(username: string) {
    return await Auth.resendSignUp(username);
}

// pass in true to sign out from all devices
async function signOut(global = false) {
    return await Auth.signOut({ global });
}

async function federatedSignIn(provider: any) {
    return await Auth.federatedSignIn({ provider });
}

async function forgotPassword(email: string) {
    return await Auth.forgotPassword(email);
}

async function forgotPasswordSubmit(email: string, code: string, newPassword: string) {
    try {
        await Auth.forgotPasswordSubmit(email, code, newPassword);
        return "Password was changed successfully.";
    } catch (err) {
        throw err;
    }
}

async function changePassword(oldPassword: string, newPassword: string) {
    try {
        const user = await Auth.currentAuthenticatedUser();
        await Auth.changePassword(user, oldPassword, newPassword);
        return "Password was changed successfully.";
    } catch (err) {
        throw err;
    }
}

function getIdToken() {
    return new Promise((resolve, reject) => {
        Auth.currentSession()
            .then((data) => {
                const idToken = data.getIdToken();
                resolve(idToken.getJwtToken());
            })
            .catch(() => {
                reject(Error("Not signed in."));
            });
    });
}

function getCurrentUser() {
    return new Promise((resolve, reject) => {
        Auth.currentSession()
            .then((data) => {
                const idToken = data.getIdToken();
                const user = idToken.payload;
                resolve({ ...user, token: idToken.getJwtToken() });
            })
            .catch(() => {
                reject(Error("Not signed in."));
            });
    });
}

export {
    signUp,
    signIn,
    confirmSignUp,
    resendConfirmationCode,
    signOut,
    federatedSignIn,
    forgotPassword,
    forgotPasswordSubmit,
    getIdToken,
    changePassword,
    getCurrentUser,
};